import './App.css';
import './Calendar.css';
import Bookings from './Bookings.js';
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useState } from 'react';
import { DateCalendar } from '@mui/x-date-pickers';
import { PanelGroup, Panel, PanelResizeHandle } from 'react-resizable-panels';
import dayjs from "dayjs"; 
 
const HOST_NAME = process.env.REACT_APP_API_HOST;
console.log(process.env);

function App() {
  const [value, setValue] = useState(dayjs());
  const BOOKINGS_URL = `https://${HOST_NAME}/api/bookings`;

  function onChange(nextValue) {
    console.log("new Value: ", nextValue);
    setValue(nextValue);
  }

  return (
    <div className="App">
      <header className="App-header h-screen-header">
        <p>
          Vizualizați programările
        </p>
      </header>
      <PanelGroup autoSaveId="example" direction="horizontal">
        {/*div className="flex h-screen-content"*/}
        {/* Left Pane */}
        <Panel id="sidebar" minSize={30} order={1} className='h-screen-content p-10'> 
          {/*div className="w-1/4 bg-gray-800 text-white p-4"*/}
          <h2 className="text-xl font-semibold">
		Dr. <span className="doctor-name">Mihai Radulescu</span>
	  </h2>
          <Bookings url={BOOKINGS_URL} date={value}>
	  </Bookings>
        </Panel>
        <PanelResizeHandle />
        {/* Right Pane with DateCalendar */}
        <Panel id="calendar" minSize={30} order={2} className='h-screen-content'>
          {/*div className="w-3/4 p-4 bg-gray-100 center"*/}
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DateCalendar views={["day", "month", "year"]}
        value={value} onChange={(newValue) => onChange(newValue)}
        className='calendar' showDaysOutsideCurrentMonth={true}/>
          </LocalizationProvider>
        </Panel>
      </PanelGroup>
    </div>
  );
}

export default App;
